import './BookNow.css'

const SQUARE_BOOKING_URL = 'https://book.squareup.com/appointments/xdv8nn9y3unx11/location/LCWE7NKQ1BJM3/services'
const USE_IFRAME_EMBED = false

export default function BookNow() {
  return (
    <section className="booknow section" aria-labelledby="booknow-heading">
      <div className="container">
        {/* Header */}
        <div className="booknow__header">
          <span className="booknow__eyebrow">Ready When You Are</span>
          <h2 className="booknow__heading" id="booknow-heading">
            Book a
            <span className="booknow__heading-script"> Session</span>
          </h2>
          <p className="booknow__intro">
            Slots fill up fast. Lock in your session through our booking platform, simple,
            and no-fuss. Have a reference image? Bring it along or send it through the
            contact form before your appointment.
          </p>
        </div>

        {/* Booking block */}
        <div className="booknow__block">
          {USE_IFRAME_EMBED ? (
            <div className="booknow__iframe-wrap">
              <iframe
                src={SQUARE_BOOKING_URL}
                title="Book a tattoo session with Jesse B Tattoos via Square"
                className="booknow__iframe"
                allow="payment"
                loading="lazy"
              />
            </div>
          ) : (
            <div className="booknow__link-block">
              {/* NEW: Two buttons */}
              <div className="booknow__cta-group">
                <a
                  href="/contact"
                  className="booknow__cta booknow__cta--secondary"
                  aria-label="New client enquiry for Jesse B Tattoos"
                >
                  New to Jesse B Tattoos
                </a>

                <a
                  href={SQUARE_BOOKING_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="booknow__cta"
                  aria-label="Returning client booking for Jesse B Tattoos (opens in new tab)"
                >
                  Returning Jesse B Tattoos Client
                </a>
              </div>

              {/* EXISTING: Steps */}
              <div className="booknow__steps" aria-label="Booking steps">
                {[
                  { step: '01', label: 'Returning Customer, Click the Orange button', desc: 'Custom tattoo, Tattoo Therapy, or Touch-Up.' },
                  { step: '02', label: 'Pick your slot', desc: 'Browse available dates and times in the Square calendar.' },
                  { step: '03', label: 'Confirm & deposit', desc: 'Secure your booking pay the deposit, fully applied to your session.' },
                ].map(({ step, label, desc }) => (
                  <div className="booknow__step" key={step}>
                    <span className="booknow__step-num" aria-hidden="true">{step}</span>
                    <div>
                      <h3 className="booknow__step-title">{label}</h3>
                      <p className="booknow__step-desc">{desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* EXISTING: Note */}
              <p className="booknow__note">
                This booking system is for returning customers only. If you’re new to Jesse B Tattoos, please{' '}
                <a href="/contact" className="booknow__contact-link">
                  send an enquiry first
                </a>{' '}
                so we can confirm your idea, design, and requirements before booking. Returning customers can book a time slot, then send through any details or reference images via the contact form or email to ensure everything is clear before your session.
              </p>
            </div>
          )}

          {/* Side info panel */}
          <aside className="booknow__info" aria-label="Booking information">
            <h3 className="booknow__info-heading">Good to Know</h3>
            <ul className="booknow__info-list">
              <li>
                <strong>Numbing Cream:</strong> Not recommended. If used, test beforehand as it can affect skin, healing, and the tattoo process.
              </li>
              <li>
                <strong>Preparation:</strong> Eat before your session, bring water/snacks for longer sittings, and bring valid ID.
              </li>
              <li>
                <strong>Deposits:</strong> $100 required to secure your booking. Applied to your final price. Non-refundable.
              </li>
              <li>
                <strong>Cancellations:</strong> Minimum 48 hours notice required. Deposits are lost if cancelled late, but can be transferred if rescheduled in time.
              </li>
              <li>
                <strong>Consultation:</strong> Always free for custom work or Tattoo Therapy.
              </li>
              <li>
                <strong>Touch-Ups:</strong> Free within 6 months for qualifying fresh work.
              </li>
            </ul>

            <div className="booknow__info-contact">
              <p>Questions before booking?</p>
              <a href="mailto:admin@jessebtattoo.com" className="booknow__email-link">
                admin@jessebtattoo.com
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  )
}